// @charset "utf-8";

import Vue from 'vue'
import Router from 'vue-router'
import simuAccountApplication from '../components/simuAccountApplication'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            redirect: '/simu-account-application'
        },
        {
            path: '/simu-account-application',
            name: 'simuAccountApplication',
            component: simuAccountApplication,
            meta: {
                keepAlive: true
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js